import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';

import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { SurgeryHeader } from 'src/pages/orders/components/orderDetails/orderSummary/shippingDetails/ShippingDetails.styled';
import {
    PaymentDetailsContainer,
    PaymentDetailsDataContainer,
    OrderPaymentContainer,
    PaymentDetailsFont,
} from './PaymentDetails.styled';
import {
    showHideSummaryModal,
    showHideRequestInvoice,
} from 'src/pages/orders/redux/actions';
import { RequestInvoiceContainer } from 'src/pages/orders/components/orderDetails/billingSummary/BillingSummary.styled';
import { UsagePriceFont } from 'src/pages/orders/components/orderDetails/billingSummary/usagePricing/UsagePricing.styled';
import { useTranslation } from 'react-i18next';

const PaymentDetails = ({
    isPaymentDetails,
    toggleCard,
    paddingValue,
    isRequestInvoice,
}) => {
    const { t } = useTranslation();
    const winWidth = window.innerWidth;

    const dispatch = useDispatch();
    const paymentReducerDetails = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.paymentDetails
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const myCaseRef = useSelector(
        (state) => state.orderSummaryReducer.myCaseRef
    );
    const orderType = useSelector(
        (state) => state.orderSummaryReducer?.orderBasicDetails?.currentOrderType
    );
    const requestInvoicePaymentHandler = () => {
        if (!isRequestInvoice) {
            return;
        }
        dispatch(
            showHideRequestInvoice({
                requestInvoiceState: true,
                myCaseRefId: myCaseRef,
                isRequestInvoiceOrderListPage: false,
                isRequestInvoiceSearchListPage: false,
            })
        );
        dispatch(
            showHideSummaryModal({
                orderSummaryModal: false,
            })
        );
    };

    return (
        <>
            <CollapsableCard
                id="orders-paymentDetails-paymentDetails-paymentDetails"
                title={t('equity.submit.paymentDetails')}
                onClick={() =>
                    toggleCard('isPaymentDetails', !isPaymentDetails)
                }
                isExpanded={isPaymentDetails}
                padding={paddingValue ? paddingValue : '0.8rem'}
                CollapsableCardIconWidthHeight={'auto'}
            >
                {isPaymentDetails && paymentReducerDetails ? (
                    <>
                        {paymentReducerDetails?.length > 0 ? (
                            <>
                                {paymentReducerDetails?.map((paymentValue) => {
                                    return (
                                        <PaymentDetailsContainer
                                            key={paymentValue?.orderNo}
                                        >
                                            {paymentValue?.salerOrg &&
                                            countryISOCode == 'US' ? (
                                                <SurgeryHeader
                                                    // mbPaddingLeft={'12px'}
                                                    mbMarginLeft={'-16px'}
                                                    mbWidth={
                                                        'calc(100% + 32px)'
                                                    }
                                                    width={'calc(100% + 32px)'}
                                                    marginLeft={'-16px'}
                                                    headerHeight={
                                                        orderType === 'KE'
                                                            ? '30px'
                                                            : '22px'
                                                    }
                                                    mbPaddingLeft={'16px'}
                                                    paddingLeft={'16px'}
                                                >
                                                    {paymentValue?.salerOrg ===
                                                    'S002'
                                                        ? t(
                                                              'orders.orderTypes.nonTissue'
                                                          )
                                                        : paymentValue?.salerOrg ===
                                                              'S030' &&
                                                          t(
                                                              'consignment.productType.type.tissue'
                                                          )}
                                                </SurgeryHeader>
                                            ) : null}

                                            <PaymentDetailsDataContainer
                                                marginLeft={orderType === 'ZOR'}
                                            >
                                                <OrderPaymentContainer
                                                    margin={'10px 0 10px 0'}
                                                >
                                                    {paymentValue?.orderNo ? (
                                                        <PaymentDetailsFont
                                                            fontFamily="AvenirNextWorld Demi"
                                                            fontSize="14px"
                                                            margin={'0 0 5px 0'}
                                                        >
                                                            {`${t(
                                                                'orders.shipTrackLabels.sapOrderId'
                                                            )}: ${
                                                                paymentValue.orderNo
                                                            }`}
                                                        </PaymentDetailsFont>
                                                    ) : null}
                                                    {paymentValue?.status ? (
                                                        <PaymentDetailsFont>
                                                            {
                                                                paymentValue.status
                                                            }
                                                        </PaymentDetailsFont>
                                                    ) : null}
                                                </OrderPaymentContainer>
                                                <OrderPaymentContainer
                                                    margin={'10px 0 10px 0'}
                                                >
                                                    {paymentValue?.paymentMethod ? (
                                                        <>
                                                            <PaymentDetailsFont
                                                                fontFamily="AvenirNextWorld Demi"
                                                                fontSize="14px"
                                                                margin={
                                                                    '0 0 5px 0'
                                                                }
                                                            >
                                                                {t(
                                                                    'equity.submit.paymentMethod'
                                                                )}
                                                            </PaymentDetailsFont>
                                                            <PaymentDetailsFont>
                                                                {(orderType ===
                                                                    'KE' &&
                                                                winWidth <=
                                                                    sizes.mobileDevice
                                                                    ? t(
                                                                          'reportUsage.record.reportPayment.PoInfoView.poText'
                                                                      )
                                                                    : '') +
                                                                    paymentValue.paymentMethod}
                                                            </PaymentDetailsFont>
                                                        </>
                                                    ) : null}
                                                </OrderPaymentContainer>
                                            </PaymentDetailsDataContainer>
                                        </PaymentDetailsContainer>
                                    );
                                })}
                                <RequestInvoiceContainer
                                    // style={{padding: winWidth <= sizes.mobileDevice ? '0px' : '0 20px'}}
                                    margin={'10px 0 0 0px'}
                                    width={'100%'}
                                >
                                    <UsagePriceFont
                                    id="orders-paymentdetails-request-invoice-link"
                                        color={'#1010EB'}
                                        fontFamily={'AvenirNextWorld Demi'}
                                        fontSize={'15px'}
                                        onClick={requestInvoicePaymentHandler}
                                        cursor={'pointer'}
                                        opacity={!isRequestInvoice && '0.3'}
                                    >
                                        {t(
                                            'orders.reportsAndInvoice.requestInvoice.requestInvoiceButton'
                                        )}
                                    </UsagePriceFont>
                                </RequestInvoiceContainer>
                            </>
                        ) : null}
                    </>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default PaymentDetails;
